export const filters = {
  methods: {
    filterByCountry(jurisdictionId) {
      this.watchlistKeys = [{ tid: jurisdictionId }];
      const filterArr = [jurisdictionId];
      this.$refs.filterBlock.changeSelectedItems(filterArr);
      this.$refs.reset = true;
    },
    onWatchlistItemClicked(id, tags) {
      this.watchlistKeys = tags;
      let filterQuery = "";
      const filterArr = [];
      tags.forEach((item) => {
        filterQuery += `&filter[${item.type}][]=${item.tid}`;
        filterArr.push(item.tid);
      });

      this.filterChanged({ queryParams: filterQuery });

      this.$refs.filterBlock.changeSelectedItems(filterArr);
      this.$refs.reset = true;
    },
    filterIdsFromUrl(urlString) {
      const queryString = urlString.substring(urlString.indexOf("?") + 1); // strip off "/search?"
      const urlParams = new URLSearchParams(queryString);
      const valuesArray = [];

      for (const [key, value] of urlParams) {
        if (key.startsWith("filter")) {
          valuesArray.push(parseInt(value));
        }
      }
      return valuesArray;
    },
    filterTypeIdsFromUrl(urlString) {
      const queryString = urlString.substring(urlString.indexOf("?") + 1); // strip off "/search?"
      const urlParams = new URLSearchParams(queryString);
      const valuesArray = [];

      for (const [key, value] of urlParams) {
        if (key.startsWith("filter")) {
          valuesArray.push(`${key}=${parseInt(value)}`);
        }
      }
      return valuesArray;
    },
  },
};
